export default __webpack_public_path__ + "static/media/logo-3d-ovato-coin-perspective-new.f66d6064.png";